import React, { useState, useEffect, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import {
  Box,
  CircularProgress,
  InputBase,
  Typography
} from "@material-ui/core/"
import styles from "./styles"
import InviteLink from "../../../../components/SideBox/components/InviteLink"
import ActionBar from "../../../../components/ActionBar"
import PagesGrid from "../../../../components/PagesGrid"
import { useDispatch } from "react-redux"
import SearchIcon from "@material-ui/icons/Search"
import MembersComponent from "./members"
import { getMembers } from "actions/organization"
import { useSelector } from "react-redux"
import noMembers from "assets/no-members-added.png"
import CheckIcon from "@material-ui/icons/Check"

const sorts = [
  {
    name: "Name",
    getVal: val => val.first_name + " " + val.last_name
  }
]

const filters = [
  {
    name: "Can Submit",
    filter: user => user.can_post,
    icon: <CheckIcon />
  },
  {
    name: "Administrator",
    filter: user => user.role === "Administrator",
    icon: <CheckIcon />
  },
  {
    name: "Moderator",
    filter: user => user.role === "Moderator",
    icon: <CheckIcon />
  },

  {
    name: "User",
    filter: user => user.role === "User",
    icon: <CheckIcon />
  }
]

const Members = ({ classes }) => {
  const [isLoading, setLoading] = useState(true)
  const [searchFilter, setSearchFilter] = useState("")
  const [sort, setSort] = useState(null)
  const [filter, setFilter] = useState(null)
  const members = useSelector(state => state.members)
  const handleSearch = e => {
    const searchValue = e.target.value
    setSearchFilter(searchValue)
  }

  const dispatch = useDispatch()
  // console.log(filter)
  useEffect(() => {
    dispatch(getMembers())
      .then(() => {
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }, [])

  return (
    <PagesGrid
      actionBar={
        <ActionBar
          searchBar={
            <div className={classes.searchBar}>
              <SearchIcon className={classes.searchIcon} />
              <InputBase
                placeholder="Search"
                className={classes.searchInput}
                onChange={e => handleSearch(e)}
              />
            </div>
          }
          sorts={sorts}
          sort={sort}
          setSort={setSort}
          filters={filters}
          filter={filter}
          setFilter={setFilter}
        />
      }
      content={
        <Fragment>
          {!isLoading && (
            <MembersComponent
              users={members}
              sort={sort}
              searchFilter={searchFilter}
              filter={filter}
            />
          )}
          {!isLoading && members.length === 0 && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              style={{ margin: "0 auto" }}
            >
              <img src={noMembers} className={classes.noConnectedImg} />
              <Typography variant="h2" className={classes.noMembersTitle}>
                No Members
              </Typography>
            </Box>
          )}
          {isLoading && (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "100%"
              }}
            >
              <CircularProgress color="primary" />
            </Box>
          )}
        </Fragment>
      }
      sideBox={
        <Box>
          <InviteLink />
        </Box>
      }
    />
  )
}

export default withStyles(styles)(Members)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Members/index.js